<template>
  <div>
	 <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Profile</strong>
          </CCardHeader>
          <CCardBody>
            
            <CRow>
              <CCol sm="6">
                <CInput
                  label="User Name" name="userName"
                  placeholder="User Name"
                />
              </CCol>
				      <CCol sm="6">
                <CInput
                  label="User Id" name="user_Id"
                  placeholder="User Id"
                />
              </CCol>
            </CRow>  

            <CRow>
              <CCol sm="6">
                <CInput
                  label="FirstName" name="firstName"
                  placeholder="Full name"
                />
              </CCol>
				      <CCol sm="6">
                <CInput
                  label="LastName" name="lastName"
                  placeholder="Last Name"
                />
              </CCol>			  
            </CRow>
			      <CRow>
              <CCol sm="6">
                <CInput
                  label="Latitude" name="latitude"
                  placeholder="Latitude"
                />
              </CCol>
				      <CCol sm="6">
                <CInput
                  label="Longitude" name="longitude"
                  placeholder="Longitude"
                />
              </CCol>
            </CRow>  

            <CRow>
              <CCol sm="6">
                <CInput
                  label="Mobile No" name="mobileNo"
                  placeholder="Mobile No"
                />
              </CCol>
				      <CCol sm="6">
                <CInput
                  label="User Email" name="UserEmail"
                  placeholder="User Email"
                />
              </CCol>
            </CRow>
      
			 <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Save</button>
			</CCol>
			 
            </CRow>
			<CRow>
			<CCol col="12" class="text-left">
				<p style="color:red;" id="profile_reponse_error"></p>
			</CCol>
		  </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
	<CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Change Password</strong>
          </CCardHeader>
          <CCardBody>           
            <CRow>
				<CCol sm="6">
					<CInput
					  label="Old Password" name="oldpassword"
					  placeholder="Old Password"
					/>
				</CCol>
				<CCol sm="6">
				<CInput
				  label="Password" name="password"
				  placeholder="Password"
				/>
				</CCol>							 
            </CRow>
			 <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="changepassword()">Change</button>
			</CCol>
			 
            </CRow>
			<CRow>
			<CCol col="12" class="text-left">
				<p style="color:red;" id="reponse_error"></p>
			</CCol>
		  </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: 'Profile',
  data () {
    return {
      setSelected:"",
	  isLoading: false,
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],     
	  siteOptions : [],
      physicalOptions : ['New physical','LIQUID'],
      customerOptions: [],
      wasteqty: ['1.0', '2.0', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0'],
      wasteshipment: [],
      wastepackaging: [],
      wastetexture: [],
      wastetrucktype: [],
      wastename: [],	
	  oldest_os_amt:0,
	  oldest_days:0,
	  invoice_number:0,
	  outstanding_amt:0,	  
      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom'],			
		Role_Id:0,
		IPAddress:0,
		Password:0,
    }
  },
  mounted () {
		$('.counterDiv').hide();
		$('.otherOptions').hide();	
		var user=JSON.parse(localStorage.getItem("user"));	  
		$('input[name=userName]').val(user[0].UserName);
		$('input[name=user_Id]').val(user[0].User_Id);
		this.Role_Id=user[0].Role_Id;
		this.IPAddress=user[0].IPAddress;
		this.Password=user[0].Password;		
		$('input[name=firstName]').val(user[0].FirstName);
		$('input[name=lastName]').val(user[0].LastName);
		$('input[name=latitude]').val(user[0].Latitude);
		$('input[name=longitude]').val(user[0].Longitude);
		$('input[name=mobileNo]').val(user[0].MobileNo);
		$('input[name=UserEmail]').val(user[0].UserEmail);
  },
  computed: {
        
   },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){
		//console.log('call');		
		this.$router.go(-1)
		//this.$router.push({path:'manage_users'})
	},
	submit(){
		var User_Id=JSON.parse(localStorage.getItem("User_Id"));
		var userName=$('input[name=userName]').val();
		var user_Id=$('input[name=user_Id]').val();
		var firstName=$('input[name=firstName]').val();
		var lastName=$('input[name=lastName]').val();
		var latitude=$('input[name=latitude]').val();
		var longitude=$('input[name=longitude]').val();
		var mobileNo=$('input[name=mobileNo]').val();
		var UserEmail=$('input[name=UserEmail]').val();
		var token=localStorage.getItem("auth");
		
		var requestInfo = {
		User_Id: User_Id,
		Role_Id: this.Role_Id,
		FirstName: firstName,
		LastName:lastName,
		UserName: userName,
		UserEmail:UserEmail,
		MobileNo:mobileNo,
		Password:this.Password,
		Status:'Active',
		ProfileImage:'',
		IPAddress:this.IPAddress,
		Latitude:latitude,
		Longitude:longitude,
		Token:token,
		Session_User_Id:User_Id,
		};
		var self =this;
		//console.log(requestInfo);
		var data = JSON.stringify(requestInfo);							
			var config = {
			  method: 'post',
			  url: apiURL+'Authentication/UpdateUserProfile',
			  headers: { 
				'Content-Type': 'application/json'
			  },
			  data : data
		};
		this.isLoading = true;
		axios(config)
		.then((result) => {		
			this.isLoading = false;	
			if(result.data.status_code==200){		
				//console.log(result);				
				//$('#profile_reponse_error').html(result.data.message);				
				var token=localStorage.getItem("auth");
				var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
				var requestInfo = {
				User_Id: Session_User_Id,		
				Token:token,
				Session_User_Id:Session_User_Id,
				};
				var self1 =self;
				var data = JSON.stringify(requestInfo);									
					var config = {
					  method: 'post',
					  url: apiURL+'ManageUsers/ViewUserProfile',
					  headers: { 
						'Content-Type': 'application/json'
					  },
					  data : data
				};
				//console.log(requestInfo);
				axios(config)
				.then((result) => {		
					this.isLoading = false;						
					if(result.data.status_code==200){
						var obj=result.data.response;
						obj[0].Token=token;						
						//console.log(JSON.stringify(obj));
						localStorage.setItem("user",JSON.stringify(obj));						
						this.$swal.fire({
							title: "Profile", 
							text: "Profile updated successfully.", 
							type: "success"					  
						}).then(function(){ 
						   location.reload();
						   }
						);						
					}else{										
						this.$swal.fire({
						  icon: 'error',
						  title: 'Oops...',
						  text: result.data.message		 
						})
					}
				  
				})
				.catch((error) => {	
					this.isLoading = false;					
					this.$swal.fire({
					  icon: 'error',
					  title: 'Oops...',
					  text: 'Something went wrong!'		 
					})
				});				
			}else{								
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		})
		.catch((error) => {
			this.isLoading = false;	
			//var errorObject=JSON.stringify(error.response.data.errors);			
			//console.log(errorObject);		   
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	},
	changepassword(){		
		
		var User_Id=JSON.parse(localStorage.getItem("User_Id"));		
		var token=localStorage.getItem("auth");
		var Old_Password=$('input[name=oldpassword]').val();
		var New_Password=$('input[name=password]').val();					
		var req = {
			User_Id:User_Id,
			Old_Password:Old_Password,
			New_Password: New_Password,
			Token:token
		};				
		var data = JSON.stringify(req);	
		var self =this;
		var config = {
		  method: 'post',
		  url: apiURL+'Authentication/UpdatePassword',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
		};
        this.isLoading = true;
		axios(config)
		.then((result) => {
			this.isLoading = false;
			//console.log(result);
			if(result.data.status_code==200){																	
				//$('#reponse_error').html(result.data.message);
				this.$swal.fire(
					'Saved',
					result.data.message,
					'success'
				);
			}else{
				//$('#reponse_error').html(result.data.message);
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: result.data.message		 
				})
			}
		  
		})
		.catch((error) => {
			this.isLoading = false;
		  //console.log(error);
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: 'Something went wrong!'		 
			})
		});
	}
  }
}
</script>
